import styles from '@styles/components/QontactPoints/Turnos/QontactPointTurnos.module.css';
import { useEffect, useRef, useState } from 'react';

import { ReactComponent as ArrowSVG } from '@assets/SVGs/QontactPoint/ArrowSVG.svg';
import { ReactComponent as CalendarSVG } from '@assets/SVGs/QontactPoint/CalendarSVG.svg';
import { ReactComponent as EliminateSVG } from '@assets/SVGs/QontactPoint/xRedSVG.svg';

import { DayPickerPopper } from '@components/General/TablePoppers';
import TimeInput from '@components/General/TimeInput';


const QPTurno = ({turno, setTurnos}) => {
    const [name, setName] = useState(turno.name)
    const [hourFrom, setHourFrom] = useState(turno.hourFrom)
    const [hourTo, setHourTo] = useState(turno.hourTo)
    const [expected, setExpected] = useState(turno.expected)

    const [selectedDays, setSelectedDays] = useState(turno.days);
    const [isOpen, setIsOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null)

    const containerRef = useRef(null);
    const daysBarRef = useRef(null);
    const anchorElement = useRef(null);
    const [popperWidth, setPopperWidth] = useState(0);


    useEffect(() => {
        const container = containerRef.current;
        const onWheel = (event) => {
            if (event.deltaY !== 0) {
                event.preventDefault(); // Prevent the default vertical scroll behavior
                container.scrollLeft += event.deltaY; // Scroll horizontally instead
            }
        };
        if (container) {
            container.addEventListener('wheel', onWheel);
        }


        const updatePopperWidth = () => {
            if (daysBarRef.current) {
                setPopperWidth(daysBarRef.current.offsetWidth);
            }
        };
        // Initial width set
        updatePopperWidth();

        // Update width on window resize
        window.addEventListener('resize', updatePopperWidth);

        // Cleanup the event listener
        return () => {
            if (container) {
                container.removeEventListener('wheel', onWheel);
            }
            window.removeEventListener('resize', updatePopperWidth);
        };
    }, []);

    useEffect(() => {
        setTurnos(prev => {
            const updatedTurnos = prev.map(t => {
                if (t.id === turno.id) {
                    return {
                        ...t,
                        name,
                        hourFrom,
                        hourTo,
                        expected,
                        days: selectedDays
                    }
                }
                return t;
            });
            return [...updatedTurnos];
        });
    }, [name, hourFrom, hourTo, expected, selectedDays]);

    const handleDayRemove = (day) => {
      setSelectedDays(selectedDays.filter(d => d !== day));
    };


    const handleClickDayDropdown = (event) => {
        setAnchorEl(anchorElement.current);
        setIsOpen((previousOpen) => !previousOpen);
    };

    const handleDelete = (e) => {
        setTurnos(prev => {
            const updatedTurnos = prev.filter(t => t.id !== turno.id);
            return [...updatedTurnos];
        });
    };

    return (
        <div className={styles['turno-container']}>
            <div className={styles['x-button']} onClick={handleDelete}>
                <EliminateSVG/>
            </div>
            <div className={styles['name-hours-container']}>
                <div className={styles['name-container']}>
                    <div className={styles['input-container']}>
                        <input 
                        type='text' 
                        placeholder='Nombre turno...' 
                        className={styles['input']}
                        value={name}
                        onChange={e => setName(e.target.value)}
                        />
                    </div>
                </div>

                <div className={styles['hours-container']}>
                    <div className={styles['hour-container']}> 
                        <p>Desde</p>
                        <TimeInput initValue={hourFrom} setHour={setHourFrom}/>
                    </div>

                    <div className={styles['hour-container']}>
                        <p>Hasta</p>
                        <TimeInput initValue={hourTo} setHour={setHourTo}/>
                    </div>

                </div>
            </div>

            <div className={styles['days-container']}>
                <p>Día/s que aplica</p>
                <div className={styles['days-bar']} ref={daysBarRef}>
                    <div className={styles['svg-container']}>
                        <CalendarSVG/>
                    </div>

                    <div className={styles['days-window']} ref={containerRef} onClick={() => {
                        setAnchorEl(anchorElement.current);
                        setIsOpen(true)
                    }}>
                        {selectedDays.length === 0 && <p style={{marginBottom: '0px', fontSize: '14px'}}>Seleccionar...</p>}
                        {selectedDays.map(day => (
                            <div key={day} className={styles['day-pill']}>
                                {day}
                                <span className={styles['remove-day']} onClick={() => handleDayRemove(day)}>&times;</span>
                            </div>
                        ))}
                    </div>

                    <div className={styles['svg-container']} style={{ 
                        transform: isOpen ? 'rotate(180deg)' : 'none',
                        transition: 'transform 0.2s ease'
                    }} onClick={handleClickDayDropdown}
                        ref={anchorElement}
                    >
                        <ArrowSVG/>
                        {isOpen && 
                        <DayPickerPopper 
                            isOpen={isOpen} 
                            setIsOpen={setIsOpen}
                            anchorElement={anchorEl} 
                            placement="bottom-end"
                            selectedDays={selectedDays}
                            setSelectedDays={setSelectedDays}
                            style={{marginTop: '12px', marginRight: '-15px', width: popperWidth}}
                        />}
                    </div>
                </div>
            </div>


            <div className={styles['quantity-container']}>
                <p>Cant. Empleados</p>
                <div className={styles['input-container']}>
                    <input 
                    type='number' 
                    placeholder='00' 
                    className={styles['input']}
                    value={expected}
                    onChange={e => setExpected(parseInt(e.target.value))}
                    />
                </div>
            </div>
            
            {/* <div className={styles['colaborador-asignar-container']} style={expected > 0 ? {cursor: 'pointer'} : {}}>
                {expected > 0 ?
                <ColaboradorActiveSVG onClick={() => console.log('hello')}/>
                :
                <ColaboradorSVG/>
                }
            </div> */}
        </div>
    )
}

export default QPTurno